import React from 'react';
import { Box, HStack, Icon, Text, VStack } from '@chakra-ui/react';

import { VendorAccount } from '../../types/shared/VendorAccount';
import { TbLock, TbLogout, TbReceipt2, TbUserCircle } from 'react-icons/tb';
import { IconType } from 'react-icons';

type Props = {
  vendorAccount: VendorAccount;
  billingLink: string | undefined;
  onLogoutPress: () => void;
  onChangePasswordPress: (value: boolean) => void;
};

export default function SideNavProfile(props: Props) {
  const {
    vendorAccount,
    billingLink,
    onLogoutPress,
    onChangePasswordPress,
  } = props;
  return (
    <VStack align="stretch" divider={<Divider />}>
      <HStack>
        <Icon as={TbUserCircle} color="blue.500" fontSize={60} />
        <VStack flex={1} justify="center" align="stretch" spacing={2}>
          <Text fontSize={18} fontWeight="bold" color="blue.500">
            {vendorAccount.name}
          </Text>
          <Text fontSize={16} color="gray.400">
            {vendorAccount.email}
          </Text>
        </VStack>
      </HStack>
      {billingLink ? (
        <Button
          label={t('Billing')}
          icon={TbReceipt2}
          href={billingLink}
          target="_blank"
        />
      ) : null}
      <Button
        label={t('Change Password')}
        icon={TbLock}
        onPress={() => onChangePasswordPress(true)}
      />
      <Button label={t('Logout')} icon={TbLogout} onPress={onLogoutPress} />
    </VStack>
  );
}

function Button(props: {
  label: string;
  icon: IconType;
  href?: string;
  target?: '_blank';
  onPress?: () => void;
}) {
  const { label, icon, onPress, ...other } = props;
  return (
    <HStack
      as={props.href ? 'a' : 'button'}
      textAlign="left"
      py={2}
      px={3}
      onClick={onPress}
      spacing={4}
      {...other}
    >
      <Icon as={icon} color="gray.900" fontSize={20} />
      <Text fontSize={18} py={1}>
        {label}
      </Text>
    </HStack>
  );
}

function Divider() {
  return <Box height="1px" backgroundColor="gray.300" my={2} />;
}
